import { render } from "./CarouselHeader.vue?vue&type=template&id=410489c4&scoped=true"
import script from "./CarouselHeader.vue?vue&type=script&lang=ts"
export * from "./CarouselHeader.vue?vue&type=script&lang=ts"

import "./CarouselHeader.vue?vue&type=style&index=0&id=410489c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-410489c4"

export default script